import apiFetch from '../apiFetch'

export default function (crotal) {
  return apiFetch({endPoint: `FichaVerraco/getDatosVerraco?crotal=` + crotal, method: 'GET', body: null})
}
